/** @file Entity kinds of the editor document and the record each kind lives in. */
import type { Doc } from './schema';

/** Kinds that live in a `Record<Id, …>` table of the document. */
export const ENTITY_KINDS = {
  image: 'images',
  bone: 'bones',
  slot: 'slots',
  attachment: 'attachments',
  skin: 'skins',
  ik: 'constraints',
  event: 'events',
  socket: 'sockets',
  animation: 'animations',
  reference: 'references',
} as const;

export type EntityKind = keyof typeof ENTITY_KINDS;
export type EntityTable<K extends EntityKind> = (typeof ENTITY_KINDS)[K];
export type Entity<K extends EntityKind> = Doc[EntityTable<K>][string];
